var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex flex-column vh-100",attrs:{"id":"app"}},[_c('Header'),_c('Body',{staticClass:"flex-fill overflow-auto"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }